<div class="map-tool-container">

  <arcgis-map [itemId]="webmapId" id="map-component" class="map-view">

    <arcgis-search position="top-left"
                   [sources]="searchSources"></arcgis-search>
    <arcgis-locate position="top-left"></arcgis-locate>

    <arcgis-expand position="top-right" group="top-right" id="layerListExpand">
      <arcgis-layer-list></arcgis-layer-list>
    </arcgis-expand>

    <arcgis-expand position="top-right" id="legendExpand" group="top-right">
      <arcgis-legend></arcgis-legend>
    </arcgis-expand>

    <arcgis-expand position="top-right" id="basemapExpand" group="top-right">
      <arcgis-basemap-gallery></arcgis-basemap-gallery>
    </arcgis-expand>

    <arcgis-expand position="bottom-right" id="measurementExpand" group="top-right">
      <arcgis-distance-measurement-2d></arcgis-distance-measurement-2d>
    </arcgis-expand>

  </arcgis-map>

  <!-- Feature table toggle bar sits between map and table -->
  <div class="feature-table-bar" (click)="toggleFeatureTable()">
    <span class="feature-table-bar-label">
      Feature Attributes Table
      <i class="fa" [class.fa-chevron-up]="featureTableOpen" [class.fa-chevron-down]="!featureTableOpen"></i>
    </span>
  </div>

  <!-- Feature table panel — shown/hidden via CSS class so the map flexes to fill the space -->
  <div class="feature-table-panel" [class.open]="featureTableOpen" #tablePanel>
    <!-- Drag handle — grab to resize panel height -->
    <div class="resize-handle" #resizeHandle title="Drag to resize">
      <span class="resize-handle-grip"></span>
    </div>
    <arcgis-feature-table reference-element="map-component" [showLayerDropdown]="true"></arcgis-feature-table>
  </div>

</div>

